__turbopack_context__.v({
  "className": "_7W5YCa_className",
});
